<template>
  <v-overlay
    :model-value="true"
    persistent
    class="d-flex blur justify-center align-center"
    content-class="d-flex flex-column align-center"
    data-testid="loadingView.overlay"
  >
    <v-progress-circular indeterminate color="primary" :size="100" :width="10" class="mb-10">
      {{ circularProgress || "" }}
    </v-progress-circular>
    <v-btn v-if="cancellable" class="ma-3" data-testid="loadingView.cancel-button" @click="cancel()"> Cancel </v-btn>
  </v-overlay>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";
import { AbortRequestEventBus, KeyEventBus } from "../../event-bus";
import { editorStateStore } from "../services/storage/editor-state-store";

const compProps = withDefaults(
  defineProps<{
    cancellable?: boolean;
    circularProgress?: number;
  }>(),
  { cancellable: true, circularProgress: 0 }
);

const emit = defineEmits(["cancel"]);

const layerId = "loadingView";

const escHandler = () => {
  if (compProps.cancellable && layerId === editorStateStore().getTopLayer) {
    cancel();
  }
};

onMounted(() => {
  editorStateStore().openLayer(layerId);
  KeyEventBus.on("esc", escHandler);
});

onBeforeUnmount(() => {
  KeyEventBus.off("esc", escHandler);
  editorStateStore().closeLayer(layerId);
});

function cancel() {
  AbortRequestEventBus.emit("abort");
  emit("cancel");
}
</script>
